// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   TextField,
//   Paper,
//   Typography,
//   IconButton,
//   MenuItem,
//   Divider,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import { Delete, Add } from "@mui/icons-material";
// import axios from "axios";
// import FileUploaderNew from "../../../citizen/AVPForms/reusableComponents/FileUploaderMuiltple";
// import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

// const documentTypes = [
//   "User Manual",
//   "Video Tutorial",
//   "FAQ",
//   "SOP",
//   "Sample Drawing",
//   "Building Byelaws & GO",
// ];

// const approvalUserManual = [
//   "LTP Registration",
//   "Land use Verification",
//   "SelfCertification Via Registration",
// ];
// const approvalFAQ = ["FASTPAS FAQ"];
// const approvalLAW = ["Building Bye Laws-2025"];
// const categoryTypes = ["Application", "Bye Laws", "EDCR"];

// const StandardForm = () => {
//   const [rows, setRows] = useState([
//     { sno: 1, category: "", description: "", docType: "", isApproval: "", fileUrl: "" },
//   ]);
//   const [successOpen, setSuccessOpen] = useState(false);
//   const [fileUrlDoc, setFileUrlDoc] = useState([]);
//   const [loading, setLoading] = useState(false);

//   console.log(fileUrlDoc,"fileUrlDoc");

//   const userInfo = Digit.UserService.getUser();
//   const authToken = userInfo?.access_token || null;

//   // Handle input change
//   const handleChange = (index, e) => {
//     const { name, value } = e.target;
//     const newRows = [...rows];
//     newRows[index][name] = value;

//     if (name === "docType" && value !== "User Manual") {
//       newRows[index].isApproval = "";
//     }

//     setRows(newRows);
//   };

//   // Add a new row
//   const handleAddRow = () => {
//     setRows([
//       ...rows,
//       { sno: rows.length + 1, category: "", description: "", docType: "", isApproval: "", fileUrl: "" },
//     ]);
//   };

//   // Delete a row
//   const handleDeleteRow = (index) => {
//     const newRows = rows.filter((_, i) => i !== index).map((row, i) => ({ ...row, sno: i + 1 }));
//     setRows(newRows);

//     setFileUrlDoc((prev) => prev.filter((f) => f.rowIndex !== index));
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//     //   const payload = {
//     //     UserManual: rows.map((row, index) => {
//     //       const uploaded = fileUrlDoc.find((f) => f.rowIndex === index);
//     //       console.log("uploaded",uploaded,fileUrlDoc);

//     //       return {
//     //         tenantId: "up",
//     //         sno: row.sno.toString(),
//     //         category: row.category,
//     //         description: row.description,
//     //         isApproved: "manual",
//     //         isSubApproved: row.isApproval || row.docType,
//     //         subCategory: row.isApproval || "N/A",
//     //         downloadLink: uploaded?.fileStoreId || "",
//     //       };
//     //     }),
//     //     RequestInfo: {
//     //       apiId: "Rainmaker",
//     //       authToken,
//     //       userInfo,
//     //       msgId: `${Date.now()}|en_IN`,
//     //     },
//     //   };

//     const payload = {
//   UserManual: rows.map((row, index) => {
//     // Try to find the uploaded file for this row
//     const uploaded = fileUrlDoc[index]; // use index if FileUploaderNew keeps order
//     console.log("uploaded", uploaded, fileUrlDoc);

//     return {
//       tenantId: "up",
//       sno: row.sno.toString(),
//       category: row.category,
//       description: row.description,
//       isApproved: "manual",
//       isSubApproved: row.isApproval || row.docType,
//       subCategory: row.isApproval || "N/A",
//       downloadLink: uploaded?.fileStoreId || "",
//     };
//   }),
//   RequestInfo: {
//     apiId: "Rainmaker",
//     authToken,
//     userInfo,
//     msgId: `${Date.now()}|en_IN`,
//   },
// };

//       console.log("📦 Payload:", payload);

//       const resp = await axios.post(`${Urls.UserManualCreate}`, payload, {
//         headers: { "Content-Type": "application/json" },
//       });

//       console.log("✅ API Response:", resp.data);
//       setSuccessOpen(true);
//     //   alert("Form submitted successfully!");
//     } catch (error) {
//       console.error("❌ API Error:", error);
//       alert("Error submitting form. Check console for details.");
//     } finally {
//       setLoading(false);
//     }
//   };
// console.log("fileUrlDoc",fileUrlDoc);

//   return (
//     <Box sx={{ mx: "auto", mt: 4, p: 2, maxWidth: "95%" }}>
//       <Paper
//         elevation={3}
//         sx={{ p: 3, mb: 4, borderRadius: 3, background: "linear-gradient(135deg, #f9f9fb, #f0f4ff)" }}
//       >
//         <Typography variant="h5" align="center" gutterBottom sx={{ color: "#1A237E", fontWeight: 600 }}>
//           Manual & Documents Form
//         </Typography>
//         <Divider sx={{ mb: 3 }} />

//         <form onSubmit={handleSubmit}>
//           {rows.map((row, index) => (
//             <Paper
//               key={index}
//               elevation={1}
//               sx={{ p: 2, mb: 2, borderRadius: 2, backgroundColor: "#fff", border: "1px solid #e0e0e0" }}
//             >
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={1.2}>
//                   <TextField label="S.No." value={row.sno} disabled size="small" fullWidth />
//                 </Grid>

//                 <Grid item xs={12} sm={2.2}>
//                   <TextField
//                     select
//                     label="Document Type"
//                     name="docType"
//                     value={row.docType}
//                     onChange={(e) => handleChange(index, e)}
//                     fullWidth
//                     size="small"
//                     required
//                   >
//                     {documentTypes.map((type) => (
//                       <MenuItem key={type} value={type}>
//                         {type}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 {(row.docType === "User Manual" ||
//                   row.docType === "Video Tutorial" ||
//                   row.docType === "Sample Drawing" ||
//                   row.docType === "SOP") && (
//                   <Grid item xs={12} sm={2.2}>
//                     <TextField
//                       select
//                       label={row.docType}
//                       name="isApproval"
//                       value={row.isApproval}
//                       onChange={(e) => handleChange(index, e)}
//                       fullWidth
//                       size="small"
//                       required
//                     >
//                       {approvalUserManual.map((type) => (
//                         <MenuItem key={type} value={type}>
//                           {type}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                 )}

//                 {row.docType === "FAQ" && (
//                   <Grid item xs={12} sm={2.2}>
//                     <TextField
//                       select
//                       label="FAQ"
//                       name="isApproval"
//                       value={row.isApproval}
//                       onChange={(e) => handleChange(index, e)}
//                       fullWidth
//                       size="small"
//                       required
//                     >
//                       {approvalFAQ.map((type) => (
//                         <MenuItem key={type} value={type}>
//                           {type}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                 )}

//                 {row.docType === "Building Byelaws & GO" && (
//                   <Grid item xs={12} sm={2.2}>
//                     <TextField
//                       select
//                       label="Building Byelaws & GO"
//                       name="isApproval"
//                       value={row.isApproval}
//                       onChange={(e) => handleChange(index, e)}
//                       fullWidth
//                       size="small"
//                       required
//                     >
//                       {approvalLAW.map((type) => (
//                         <MenuItem key={type} value={type}>
//                           {type}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                 )}

//                 <Grid item xs={12} sm={2.2}>
//                   <TextField
//                     select
//                     label="Category"
//                     name="category"
//                     value={row.category}
//                     onChange={(e) => handleChange(index, e)}
//                     fullWidth
//                     size="small"
//                     required
//                   >
//                     {categoryTypes.map((type) => (
//                       <MenuItem key={type} value={type}>
//                         {type}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} sm={2.4}>
//                   <TextField
//                     label="Description"
//                     name="description"
//                     value={row.description}
//                     onChange={(e) => handleChange(index, e)}
//                     fullWidth
//                     size="small"
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={2.8}>
//                   <FileUploaderNew
//                     label="Upload Document"
//                     name={`fileUploader-${index}`}
//                     validationMsg="(jpg, jpeg, pdf, png ,dxl file only and Max file Size 10 MB)"
//                     tab={2}
//                     maxFiles={5}
//                     uploadedDocs={fileUrlDoc}
//                     setUploadedDocs={setFileUrlDoc}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={0.8} display="flex" justifyContent="center" alignItems="center">
//                   <IconButton color="error" onClick={() => handleDeleteRow(index)}>
//                     <Delete />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             </Paper>
//           ))}

//           <Box display="flex" justifyContent="center" gap={2} mt={2}>
//             <Button
//               variant="outlined"
//               startIcon={<Add />}
//               onClick={handleAddRow}
//               disabled={loading}
//               sx={{ textTransform: "none", borderColor: "#1A237E", color: "#1A237E", "&:hover": { backgroundColor: "#e8eaf6" } }}
//             >
//               Add Row
//             </Button>
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               disabled={loading}
//               sx={{ textTransform: "none", backgroundColor: "#1A237E", "&:hover": { backgroundColor: "#303f9f" } }}
//             >
//               {loading ? "Submitting..." : "Submit All"}
//             </Button>
//           </Box>
//         </form>

//         <Snackbar
//   open={successOpen}
//   autoHideDuration={4000}
//   onClose={() => setSuccessOpen(false)}
//   anchorOrigin={{ vertical: "top", horizontal: "center" }}
// >
//   <Alert onClose={() => setSuccessOpen(false)} severity="success" sx={{ width: "100%" }}>
//     Form submitted successfully!
//   </Alert>
// </Snackbar>

//       </Paper>
//       {rows.length > 0 && (
//         <Paper
//           elevation={2}
//           sx={{
//             p: 2,
//             borderRadius: 2,
//             border: "1px solid #e0e0e0",
//             backgroundColor: "#fafbff",
//           }}
//         >
//           <Typography
//             variant="h6"
//             gutterBottom
//             sx={{ color: "#1A237E", fontWeight: 600 }}
//           >
//             Live Preview
//           </Typography>
//           <Table size="small">
//             <TableHead sx={{ backgroundColor: "#e8eaf6" }}>
//               <TableRow>
//                 <TableCell>S.No.</TableCell>
//                 <TableCell>Category</TableCell>
//                 <TableCell>Description</TableCell>
//                 <TableCell>Document Type</TableCell>
//                 <TableCell>Sub Type</TableCell>
//                 <TableCell>File</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.map((row) => (
//                 <TableRow key={row.sno}>
//                   <TableCell>{row.sno}</TableCell>
//                   <TableCell>{row.category}</TableCell>
//                   <TableCell>{row.description}</TableCell>
//                   <TableCell>{row.docType}</TableCell>
//                   <TableCell>{row.isApproval || "N/A"}</TableCell>
//                   <TableCell>
//                     {row.fileUrl ? (
//                       <a
//                         href={row.fileUrl}
//                         target="_blank"
//                         rel="noreferrer"
//                         style={{ color: "#1A237E" }}
//                       >
//                         View
//                       </a>
//                     ) : (
//                       "-"
//                     )}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}
//     </Box>
//   );
// };

// export default StandardForm;

// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   TextField,
//   Paper,
//   Typography,
//   IconButton,
//   MenuItem,
//   Divider,
//   Snackbar,
//   Alert,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
// } from "@mui/material";
// import { Delete, Add } from "@mui/icons-material";
// import axios from "axios";
// import FileUploaderNew from "../../../citizen/AVPForms/reusableComponents/FileUploaderMuiltple";
// import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

// const documentTypes = [
//   "User Manual",
//   "Video Tutorial",
//   "FAQ",
//   "SOP",
//   "Sample Drawing",
//   "Building Byelaws & GO",
// ];

// const approvalUserManual = [
//   "LTP Registration",
//   "Land use Verification",
//   "SelfCertification Via Registration",
// ];
// const approvalFAQ = ["FASTPAS FAQ"];
// const approvalLAW = ["Building Bye Laws-2025"];
// const categoryTypes = ["Application", "Bye Laws", "EDCR"];

// const StandardForm = () => {
//   const [rows, setRows] = useState([
//     { sno: 1, category: "", description: "", docType: "", isApproval: "", fileUrl: "" },
//   ]);
//   const [fileUrlDoc, setFileUrlDoc] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [successOpen, setSuccessOpen] = useState(false);

//   const userInfo = Digit.UserService.getUser();
//   const authToken = userInfo?.access_token || null;

//   // Handle input change
//   const handleChange = (index, e) => {
//     const { name, value } = e.target;
//     const newRows = [...rows];
//     newRows[index][name] = value;

//     if (name === "docType" && value !== "User Manual") {
//       newRows[index].isApproval = "";
//     }

//     setRows(newRows);
//   };

//   // Add a new row
//   const handleAddRow = () => {
//     setRows([
//       ...rows,
//       { sno: rows.length + 1, category: "", description: "", docType: "", isApproval: "", fileUrl: "" },
//     ]);
//   };

//   // Delete a row
//   const handleDeleteRow = (index) => {
//     const newRows = rows.filter((_, i) => i !== index).map((row, i) => ({ ...row, sno: i + 1 }));
//     setRows(newRows);

//     setFileUrlDoc((prev) => prev.filter((f) => f.rowIndex !== index));
//   };

//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const payload = {
//         UserManual: rows.map((row, index) => {
//           const uploaded = fileUrlDoc[index]; // use index if FileUploaderNew keeps order

//           return {
//             tenantId: "up",
//             sno: row.sno.toString(),
//             category: row.category,
//             description: row.description,
//             isApproved: "manual",
//             isSubApproved: row.isApproval || row.docType,
//             subCategory: row.isApproval || "N/A",
//             downloadLink: uploaded?.fileStoreId || "",
//           };
//         }),
//         RequestInfo: {
//           apiId: "Rainmaker",
//           authToken,
//           userInfo,
//           msgId: `${Date.now()}|en_IN`,
//         },
//       };

//       console.log("📦 Payload:", payload);

//       const resp = await axios.post(`${Urls.UserManualCreate}`, payload, {
//         headers: { "Content-Type": "application/json" },
//       });

//       console.log("✅ API Response:", resp.data);
//       setSuccessOpen(true);
//     } catch (error) {
//       console.error("❌ API Error:", error);
//       alert("Error submitting form. Check console for details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ mx: "auto", mt: 4, p: 2, maxWidth: "95%" }}>
//       <Paper
//         elevation={3}
//         sx={{ p: 3, mb: 4, borderRadius: 3, background: "linear-gradient(135deg, #f9f9fb, #f0f4ff)" }}
//       >
//         <Typography variant="h5" align="center" gutterBottom sx={{ color: "#1A237E", fontWeight: 600 }}>
//           Manual & Documents Form
//         </Typography>
//         <Divider sx={{ mb: 3 }} />

//         <form onSubmit={handleSubmit}>
//           {rows.map((row, index) => (
//             <Paper
//               key={index}
//               elevation={1}
//               sx={{ p: 2, mb: 2, borderRadius: 2, backgroundColor: "#fff", border: "1px solid #e0e0e0" }}
//             >
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={1.2}>
//                   <TextField label="S.No." value={row.sno} disabled size="small" fullWidth />
//                 </Grid>

//                 <Grid item xs={12} sm={2.2}>
//                   <TextField
//                     select
//                     label="Document Type"
//                     name="docType"
//                     value={row.docType}
//                     onChange={(e) => handleChange(index, e)}
//                     fullWidth
//                     size="small"
//                     required
//                   >
//                     {documentTypes.map((type) => (
//                       <MenuItem key={type} value={type}>
//                         {type}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 {(row.docType === "User Manual" ||
//                   row.docType === "Video Tutorial" ||
//                   row.docType === "Sample Drawing" ||
//                   row.docType === "SOP") && (
//                   <Grid item xs={12} sm={2.2}>
//                     <TextField
//                       select
//                       label={row.docType}
//                       name="isApproval"
//                       value={row.isApproval}
//                       onChange={(e) => handleChange(index, e)}
//                       fullWidth
//                       size="small"
//                       required
//                     >
//                       {approvalUserManual.map((type) => (
//                         <MenuItem key={type} value={type}>
//                           {type}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                 )}

//                 {row.docType === "FAQ" && (
//                   <Grid item xs={12} sm={2.2}>
//                     <TextField
//                       select
//                       label="FAQ"
//                       name="isApproval"
//                       value={row.isApproval}
//                       onChange={(e) => handleChange(index, e)}
//                       fullWidth
//                       size="small"
//                       required
//                     >
//                       {approvalFAQ.map((type) => (
//                         <MenuItem key={type} value={type}>
//                           {type}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                 )}

//                 {row.docType === "Building Byelaws & GO" && (
//                   <Grid item xs={12} sm={2.2}>
//                     <TextField
//                       select
//                       label="Building Byelaws & GO"
//                       name="isApproval"
//                       value={row.isApproval}
//                       onChange={(e) => handleChange(index, e)}
//                       fullWidth
//                       size="small"
//                       required
//                     >
//                       {approvalLAW.map((type) => (
//                         <MenuItem key={type} value={type}>
//                           {type}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                 )}

//                 <Grid item xs={12} sm={2.2}>
//                   <TextField
//                     select
//                     label="Category"
//                     name="category"
//                     value={row.category}
//                     onChange={(e) => handleChange(index, e)}
//                     fullWidth
//                     size="small"
//                     required
//                   >
//                     {categoryTypes.map((type) => (
//                       <MenuItem key={type} value={type}>
//                         {type}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 <Grid item xs={12} sm={2.4}>
//                   <TextField
//                     label="Description"
//                     name="description"
//                     value={row.description}
//                     onChange={(e) => handleChange(index, e)}
//                     fullWidth
//                     size="small"
//                     required
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={2.8}>
//                   <FileUploaderNew
//                     label="Upload Document"
//                     name={`fileUploader-${index}`}
//                     validationMsg="(jpg, jpeg, pdf, png ,dxl file only and Max file Size 10 MB)"
//                     tab={2}
//                     maxFiles={5}
//                     uploadedDocs={fileUrlDoc}
//                     setUploadedDocs={setFileUrlDoc}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={0.8} display="flex" justifyContent="center" alignItems="center">
//                   <IconButton color="error" onClick={() => handleDeleteRow(index)}>
//                     <Delete />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             </Paper>
//           ))}

//           <Box display="flex" justifyContent="center" gap={2} mt={2}>
//             <Button
//               variant="outlined"
//               startIcon={<Add />}
//               onClick={handleAddRow}
//               disabled={loading}
//               sx={{
//                 textTransform: "none",
//                 borderColor: "#1A237E",
//                 color: "#1A237E",
//                 "&:hover": { backgroundColor: "#e8eaf6" },
//               }}
//             >
//               Add Row
//             </Button>
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               disabled={loading}
//               sx={{
//                 textTransform: "none",
//                 backgroundColor: "#1A237E",
//                 "&:hover": { backgroundColor: "#303f9f" },
//               }}
//             >
//               {loading ? "Submitting..." : "Submit All"}
//             </Button>
//           </Box>
//         </form>
//       </Paper>

//       {/* Live Preview Table */}
//       {rows.length > 0 && (
//         <Paper
//           elevation={2}
//           sx={{ p: 2, borderRadius: 2, border: "1px solid #e0e0e0", backgroundColor: "#fafbff" }}
//         >
//           <Typography variant="h6" gutterBottom sx={{ color: "#1A237E", fontWeight: 600 }}>
//             Live Preview
//           </Typography>
//           <Table size="small">
//             <TableHead sx={{ backgroundColor: "#e8eaf6" }}>
//               <TableRow>
//                 <TableCell>S.No.</TableCell>
//                 <TableCell>Category</TableCell>
//                 <TableCell>Description</TableCell>
//                 <TableCell>Document Type</TableCell>
//                 <TableCell>Sub Type</TableCell>
//                 <TableCell>File</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.map((row, i) => (
//                 <TableRow key={row.sno}>
//                   <TableCell>{row.sno}</TableCell>
//                   <TableCell>{row.category}</TableCell>
//                   <TableCell>{row.description}</TableCell>
//                   <TableCell>{row.docType}</TableCell>
//                   <TableCell>{row.isApproval || "N/A"}</TableCell>
//                   <TableCell>
//                     {fileUrlDoc[i]?.fileStoreId ? (
//                       <a
//                         href={fileUrlDoc[i].fileStoreId}
//                         target="_blank"
//                         rel="noreferrer"
//                         style={{ color: "#1A237E" }}
//                       >
//                         View
//                       </a>
//                     ) : (
//                       "-"
//                     )}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}

//       {/* Success Snackbar */}
//       <Snackbar
//         open={successOpen}
//         autoHideDuration={4000}
//         onClose={() => setSuccessOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert onClose={() => setSuccessOpen(false)} severity="success" sx={{ width: "100%" }}>
//           Form submitted successfully!
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default StandardForm;

import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Paper,
  Typography,
  IconButton,
  MenuItem,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Delete, Add, Close } from "@mui/icons-material"; // Added Close icon
import axios from "axios";
import FileUploaderNew from "../../../citizen/AVPForms/reusableComponents/FileUploaderMuiltple";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import UniversalFileUploader from "../../../citizen/AVPForms/reusableComponents/UniversalFileUploader";

const documentTypes = ["User Manual", "Video Tutorial", "Training Video", "FAQ", "SOP", "Sample Drawing", "Building Byelaws and GO"];

const approvalUserManual = ["LTP Registration", "Land use Verification", "SelfCertification Via Registration"];
const approvalFAQ = ["FASTPAS FAQ"];
const approvalLAW = ["Building Bye Laws-2025"];
const visibilityType = ["Department Only", "Public"];
const categoryTypes = ["Application", "Bye Laws", "EDCR", "GO"];

const StandardForm = ({ onClose }) => {
  // Added onClose prop
  const [rows, setRows] = useState([{ sno: 1, category: "", description: "", docType: "", isApproval: "", typeOfUser: "", fileUrl: "" }]);
  const [fileUrlDoc, setFileUrlDoc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const userInfo = Digit.UserService.getUser();
  const authToken = userInfo?.access_token || null;

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newRows = [...rows];
    newRows[index][name] = value;

    if (name === "docType" && value !== "User Manual") {
      newRows[index].isApproval = "";
    }
    if (name === "typeOfUser" && value !== "Department Only") {
      newRows[index].typeOdUser = "";
    }

    setRows(newRows);
  };

  const handleAddRow = () => {
    setRows([...rows, { sno: rows.length + 1, category: "", description: "", docType: "", isApproval: "", fileUrl: "" }]);
  };

  const handleDeleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index).map((row, i) => ({ ...row, sno: i + 1 }));
    setRows(newRows);
    setFileUrlDoc((prev) => prev.filter((f) => f.rowIndex !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setShowErrors(true);
    try {
      const payload = {
        UserManual: rows.map((row, index) => {
          const uploaded = fileUrlDoc[index];
          return {
            tenantId: "up",
            sno: row.sno.toString(),
            category: row.category,
            description: row.description,
            isApproved: "manual",
            isSubApproved: row.docType || "N/A",
            subCategory: row.isApproval || "N/A",
            downloadLink: uploaded?.fileStoreId || "",
            typeOfUser: row.typeOfUser || "",
          };
        }),
        RequestInfo: {
          apiId: "Rainmaker",
          authToken,
          userInfo,
          msgId: `${Date.now()}|en_IN`,
        },
      };

      console.log("📦 Payload:", payload);

      await axios.post(`${Urls.UserManualCreate}`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      setOpenDialog(true);
    } catch (error) {
      console.error("❌ API Error:", error);
      alert("Error submitting form. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setOpenDialog(false);
    if (onClose) {
      onClose(); // Close the entire form after successful submission
    }
  };

  const handleCancel = () => {
    if (onClose) {
      onClose(); // Close the form when cancel/close is clicked
    }
  };

  return (
    <Box sx={{ mx: "auto", mt: 4, p: 2, maxWidth: "95%" }}>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          mb: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #f9f9fb, #f0f4ff)",
          position: "relative", // Added for close button positioning
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleCancel}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#1A237E",
          }}
        >
          <Close />
        </IconButton>

        <Typography variant="h5" align="center" gutterBottom sx={{ color: "#1A237E", fontWeight: 600 }}>
          Manual & Documents Form
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <form onSubmit={handleSubmit}>
          {rows.map((row, index) => (
            <Paper key={index} elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2, backgroundColor: "#fff", border: "1px solid #e0e0e0" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={1}>
                  <TextField label="S.No." value={row.sno} disabled size="small" fullWidth />
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    select
                    label="Document Type"
                    name="docType"
                    value={row.docType}
                    onChange={(e) => handleChange(index, e)}
                    fullWidth
                    size="small"
                    required
                  >
                    {documentTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {(row.docType === "User Manual" ||
                  row.docType === "Training Video" ||
                  row.docType === "Video Tutorial" ||
                  row.docType === "Sample Drawing" ||
                  row.docType === "SOP") && (
                  <Grid item xs={12} sm={2}>
                    <TextField
                      select
                      label={row.docType}
                      name="isApproval"
                      value={row.isApproval}
                      onChange={(e) => handleChange(index, e)}
                      fullWidth
                      size="small"
                      required
                    >
                      {approvalUserManual.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}

                {row.docType === "FAQ" && (
                  <Grid item xs={12} sm={2}>
                    <TextField
                      select
                      label="FAQ"
                      name="isApproval"
                      value={row.isApproval}
                      onChange={(e) => handleChange(index, e)}
                      fullWidth
                      size="small"
                      required
                    >
                      {approvalFAQ.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}

                {row.docType === "Building Byelaws and GO" && (
                  <Grid item xs={12} sm={2}>
                    <TextField
                      select
                      label="Building Byelaws and GO"
                      name="isApproval"
                      value={row.isApproval}
                      onChange={(e) => handleChange(index, e)}
                      fullWidth
                      size="small"
                      required
                    >
                      {approvalLAW.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}

                <Grid item xs={12} sm={2}>
                  <TextField
                    select
                    label="Category"
                    name="category"
                    value={row.category}
                    onChange={(e) => handleChange(index, e)}
                    fullWidth
                    size="small"
                    required
                  >
                    {categoryTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    label="Description"
                    name="description"
                    value={row.description}
                    onChange={(e) => handleChange(index, e)}
                    fullWidth
                    size="small"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <TextField
                    select
                    label="Visibility"
                    name="typeOfUser"
                    value={row.typeOfUser || ""}
                    onChange={(e) => handleChange(index, e)}
                    fullWidth
                    size="small"
                    required
                  >
                    {visibilityType.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <UniversalFileUploader
                    label="Upload your files"
                    name={`fileUploader-${index}`}
                    uploadedDocs={fileUrlDoc}
                    setUploadedDocs={setFileUrlDoc}
                    maxFiles={5}
                    required
                    showError={showErrors && fileUrlDoc.filter((f) => f.documentType === `fileUploader-${index}`).length === 0}
                  />
                </Grid>

                <Grid item xs={12} sm={1} display="flex" justifyContent="center" alignItems="center">
                  <IconButton color="error" onClick={() => handleDeleteRow(index)}>
                    <Delete />
                  </IconButton>
                </Grid>
              </Grid>
            </Paper>
          ))}

          <Box display="flex" justifyContent="center" gap={2} mt={2}>
            <Button
              variant="outlined"
              startIcon={<Add />}
              onClick={handleAddRow}
              disabled={loading}
              sx={{ textTransform: "none", borderColor: "#1A237E", color: "#1A237E", "&:hover": { backgroundColor: "#e8eaf6" } }}
            >
              Add Row
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              sx={{ textTransform: "none", backgroundColor: "#1A237E", "&:hover": { backgroundColor: "#303f9f" } }}
            >
              {loading ? "Submitting..." : "Submit All"}
            </Button>
            <Button variant="outlined" color="error" onClick={handleCancel} disabled={loading} sx={{ textTransform: "none" }}>
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>

      {/* Live Preview Table */}
      {rows.length > 0 && (
        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, border: "1px solid #e0e0e0", backgroundColor: "#fafbff" }}>
          <Typography variant="h6" gutterBottom sx={{ color: "#1A237E", fontWeight: 600 }}>
            Live Preview
          </Typography>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#e8eaf6" }}>
              <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Document Type</TableCell>
                <TableCell>Sub Type</TableCell>
                <TableCell>File</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => (
                <TableRow key={row.sno}>
                  <TableCell>{row.sno}</TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell>{row.docType}</TableCell>
                  <TableCell>{row.isApproval || "N/A"}</TableCell>
                  <TableCell>
                    {fileUrlDoc[i]?.fileStoreId ? (
                      <a href={fileUrlDoc[i].fileStoreId} target="_blank" rel="noreferrer" style={{ color: "#1A237E" }}>
                        View
                      </a>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}

      {/* Success Dialog */}
      <Dialog open={openDialog} onClose={handleSuccessClose}>
        <DialogTitle>Success</DialogTitle>
        <DialogContent>
          <Typography>Form submitted successfully!</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StandardForm;
